// extracted by mini-css-extract-plugin
module.exports = {"Summary":"Summary_Summary__7Jvdq"};